var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 104.6",
    style: {
      enableBackground: "new 0 0 104 104.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#064B93;}\n\t.st1{fill:#FBBA00;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#FFFFFF;stroke:#FEFFFF;stroke-width:0.5;}\n\t.st4{fill:#004B93;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Dashboard",
    transform: "translate(0.13 -0.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve",
    transform: "translate(-0.13 0.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    className: "st0",
    d: "M0,62h104l0,0v32c0,5.5-4.5,10-10,10H10c-5.5,0-10-4.5-10-10V62L0,62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    className: "st1",
    d: "M104,62H0l0,0V10C0,4.5,4.5,0,10,0h84c5.5,0,10,4.5,10,10V62L104,62z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.9,70.9c1.6,0,3.1,0.3,4.5,0.9c1.4,0.6,2.6,1.4,3.7,2.5c1,1,1.9,2.3,2.5,3.7c0.6,1.4,0.9,2.9,0.9,4.5 s-0.3,3.1-0.9,4.5c-0.6,1.4-1.4,2.6-2.5,3.7c-1,1-2.3,1.9-3.7,2.5C42,93.7,40.5,94,38.9,94h-6.6V70.9H38.9z M38.9,91 c1.2,0,2.3-0.2,3.3-0.7c1-0.5,1.9-1.1,2.7-1.8c0.8-0.8,1.4-1.7,1.8-2.7s0.7-2.1,0.7-3.3s-0.2-2.3-0.7-3.3s-1-1.9-1.8-2.7 c-0.8-0.8-1.6-1.4-2.7-1.8c-1-0.5-2.1-0.7-3.3-0.7h-3.5v17H38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.2,81.7c1,0.6,1.8,1.3,2.5,2.3s1,2.1,1,3.4c0,0.9-0.2,1.7-0.5,2.5s-0.8,1.5-1.4,2.1 c-0.6,0.6-1.3,1.1-2.1,1.4C66.9,93.8,66,94,65.1,94h-9.8V70.9h7.9c0.9,0,1.7,0.2,2.5,0.5c0.8,0.3,1.5,0.8,2.1,1.4 c0.6,0.6,1.1,1.3,1.4,2.1s0.5,1.6,0.5,2.5c0,0.8-0.1,1.6-0.4,2.3C69.1,80.5,68.7,81.2,68.2,81.7z M66.7,77.4c0-1-0.3-1.8-1-2.5 c-0.7-0.7-1.5-1-2.5-1h-4.8v7h4.8c1,0,1.8-0.3,2.5-1C66.4,79.2,66.7,78.4,66.7,77.4z M65.1,91c0.5,0,0.9-0.1,1.3-0.3 c0.4-0.2,0.8-0.4,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.1s0.3-0.9,0.3-1.4c0-0.5-0.1-0.9-0.3-1.4s-0.4-0.8-0.7-1.1 c-0.3-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.3-1.3-0.3h-6.7v7H65.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_775",
    transform: "translate(5.887 0.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1416",
    className: "st4",
    d: "M23.5,16.2h-6.9c-0.5,0-0.8,0.4-0.8,0.9V61c0,0.5,0.3,0.9,0.8,0.9h6.9 c0.5,0,0.8-0.4,0.8-0.9V17.1C24.4,16.6,24,16.2,23.5,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1417",
    className: "st5",
    d: "M7.7,15.5H0.8C0.3,15.5,0,16,0,16.4v43.9c0,0.5,0.3,0.9,0.8,0.9h6.9c0.5,0,0.8-0.4,0.8-0.9 V16.4C8.5,16,8.2,15.5,7.7,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1418",
    className: "st5",
    d: "M40,10.8h-6.9c-0.5,0-0.8,0.4-0.8,0.9v48.7c0,0.5,0.3,0.9,0.8,0.9H40 c0.5,0,0.8-0.4,0.8-0.9V11.7C40.8,11.2,40.5,10.8,40,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1419",
    className: "st4",
    d: "M56.5,6.1h-6.9c-0.5,0-0.8,0.4-0.8,0.9v54c0,0.5,0.3,0.9,0.8,0.9h6.9 c0.5,0,0.8-0.4,0.8-0.9V7C57.3,6.6,57,6.2,56.5,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1420",
    className: "st4",
    d: "M89.8,6.1h-6.9c-0.5,0-0.8,0.4-0.8,0.9v54c0,0.5,0.3,0.9,0.8,0.9h6.9 c0.5,0,0.8-0.4,0.8-0.9V7C90.6,6.6,90.3,6.2,89.8,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1421",
    className: "st5",
    d: "M73,0h-7c-0.5,0-0.8,0.4-0.8,0.9v59.4c0,0.5,0.3,0.9,0.8,0.9h7c0.5,0,0.8-0.4,0.8-0.9V0.9 C73.8,0.4,73.4,0,73,0L73,0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDashboard);
export default __webpack_public_path__ + "static/media/Logo-Dashboard.43cfdc54c42e3ec7efebf0beafd6fedb.svg";
export { ForwardRef as ReactComponent };